const getMonth = (d: Date, format: string = 'short') =>
  new Date(d).toLocaleString('default', { month: format });

export default getMonth;
